import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, requiredRoles = [] }) => {
  const { authenticated, loading, hasRole, login } = useAuth();
  const location = useLocation();
  const loginTriggered = useRef(false);

  // Trigger login directly to Keycloak when not authenticated (only once)
  useEffect(() => {
    if (!authenticated && !loading && !loginTriggered.current) {
      console.log('🛡️ Usuario no autenticado, redirigiendo a Keycloak...');
      // Store the attempted URL for post-login redirect
      sessionStorage.setItem('keycloak_original_path', location.pathname);
      loginTriggered.current = true;
      login();
    }
  }, [authenticated, loading, login, location.pathname]);

  // Show loading while Keycloak is initializing
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );
  }

  // Redirect to Keycloak login if not authenticated
  if (!authenticated) {
    // Show loading while redirecting
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <div className="text-center">
          <div className="spinner-border text-primary mb-3" role="status">
            <span className="sr-only">Redirecting to login...</span>
          </div>
          <p className="text-muted">Redirigiendo a autenticación...</p>
        </div>
      </div>
    );
  }

  // Check roles if requiredRoles is provided
  if (requiredRoles.length > 0) {
    const hasRequiredRole = requiredRoles.some(role => hasRole(role));
    if (!hasRequiredRole) {
      return (
        <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
          <div className="text-center">
            <h3 className="text-danger">Acceso Denegado</h3>
            <p className="text-muted">No tienes los permisos necesarios para acceder a esta página.</p>
          </div>
        </div>
      );
    }
  }

  return children;
};

export default ProtectedRoute; 